import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useMicrophoneHelpDialogStyles = makeStyles({
  surface: {
    "@media (max-width: 480px)": {
      maxWidth: "320px",
      padding: designTokens.spacing[4],
    },
  },
  title: {
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize.sm,
      paddingRight: designTokens.spacing[6],
    },
  },
  content: {
    "@media (max-width: 480px)": {
      paddingTop: designTokens.spacing[2],
    },
  },
  grid: {
    display: "grid",
    gap: designTokens.spacing[2],
    "@media (max-width: 480px)": {
      gap: designTokens.spacing[1],
      fontSize: designTokens.fontSize.xs,
    },
  },
  closeButton: {
    position: "absolute",
    top: designTokens.spacing[2],
    right: designTokens.spacing[2],
  },
});
